
export const MESSAGE = 'MESSAGE';
export const MESSAGE1 = 'MESSAGE1';
export const MESSAGE2 = 'MESSAGE2';
export const MESSAGE3= "MESSAGE3"
export const MESSAGE5 = "MESSAGE5"
export const LOGGEDIN = 'LOGGEDIN';
export const PROFILE = 'PROFILE';
export const DISTRIBUTOR = 'DISTRIBUTOR';
export const RIGHTS = 'RIGHTS';
export const ROLE = 'ROLE'


// Masters
export const CATEGORIES = 'CATEGORIES'
export const SUBCATEGORIES= 'SUBCATEGORIES'
export const CASTS= 'CASTS'
export const GENRE= 'GENRE'
export const LANGUAGES= 'LANGUAGES'
export const COUNTRY = 'COUNTRY'
export const SUBADMINS = 'SUBADMINS'
export const PAYMENTGATEWAY = 'PAYMENTGATEWAY'

// Subscription
export const SUBSCRIPTIONS = 'SUBSCRIPTIONS'
export const MODULES = "MODULES"

// Reports

export const REPORTS = "REPORTS"

//Bank Details

export const BANKDETAILS = "BANKDETAILS"
export const BANKDETAILCREATE = "BANKDETAILCREATE"
export const BANKDETAILSLIST = "BANKDETAILSLIST"

//file festival

export const FILMFESTIVALFORMDATA = "FILMFESTIVALFORMDATA"
export const FILMFESTIVALFORMDETAILS = "FILMFESTIVALFORMDETAILS"


// producer

export const PRODUCER = 'PRODUCER'
export const PRODUCERMOVIE = 'PRODUCERMOVIE'
export const PRODUCERFORMDATA = 'PRODUCERFORMDATA'
export const PRODUCERFORMDETAILS = 'PRODUCERFORMDETAILS'

//Razorpay
export const RAZORPAYRES = "RAZORPAYRES"
export const PAYMENTMSG = 'PAYMENTMSG'

//  subTitle delete
export const SUBTITLE = "SUBTITLE"
export const AUDIOFILE = "AUDIOFILE"
export const COUNTRYFILE = "COUNTRYFILE"

// Customer
export const CUSTOMERS = "CUSTOMERS"
export const CUSTOMER = "CUSTOMER"
export const ACTCUSTOMERS = "ACTCUSTOMERS"



// Merchandise
export const NOTIFICATIONS = "NOTIFICATIONS"
export const NOTIFICATIONS_COUNT = "NOTIFICATIONS_COUNT"

export const SLIDER_BANNERS = "SLIDER_BANNERS"

// Movie
export const MOVIES = "MOVIES"
export const MOVIE = "MOVIE"
export const UPCOMING_MOVIES = "UPCOMING_MOVIES"
export const MOVIE_WATCH_USER = "MOVIE_WATCH_USER"
export const VIDEO_LINK_DELETE = "MOVIE_LINK_DELETE"
export const MOVIE_NAME = "MOVIE_NAME"
export const MOVIE_REPORT = "MOVIE_REPORT"



// Transaction
export const TRANSACTIONS = "TRANSACTIONS"
export const TRANSACTIONDATELIS = "TRANSACTIONDATELIS"
export const ALLTRANSACTIONS = 'ALLTRANSACTIONS'

// Watchhours
export const WATCHHOURS = "WATCHHOURS"

// Web Series
export const EPISODES = "EPISODES"
export const EPISODE = "EPISODE"
export const SERIES = "SERIES"
export const SERIESDETAILS = "SERIESDETAILS"
export const SERIES_NAME = "SERIES_NAME"
export const EPISODE_WATCH_USER = "EPISODE_WATCH_USER"
export const SEASON = "SEASON"
export const SERIES_REPORT = "SERIES_REPORT"


// Setting
export const ABOUTUS = "ABOUTUS"
export const PRIVACYPOLICY = "PRIVACYPOLICY"
export const TERMSCONDITIONS = "TERMSCONDITIONS"
export const REFUNDPOLICY = "REFUNDPOLICY"
export const FILE_UPLOAD = "FILE_UPLOAD"
export const FILE_DOWNLOAD = "FILE_DOWNLOAD"


// Dashboard
export const TOTALUSERS = "TOTALUSERS"
export const DASHBOARDCOUNT = "DASHBOARDCOUNT"
export const DASHBOARDMOVIES = "DASHBOARDMOVIES"
export const TOTALSUBSCRIBEUSER = "TOTALSUBSCRIBEUSER"
export const MONTHLYREVENUE = "MONTHLYREVENUE"
export const TOTALREVENUE = "TOTALREVENUE"
export const TV_SHOW_DASHBOARD = "TV_SHOW_DASHBOARD"
export const RECENT_SUBSCRIBER_DASHBOARD = "RECENT_SUBSCRIBER_DASHBOARD"
export const DAILY_REVENUE = "DAILY_REVENUE"
export const RENEWAL = "RENEWAL"



// Complaint
export const COMPLAINTS = "COMPLAINTS"
